export default (
	style = '',
) => ({
	selected_categories: [],
	categories: [],
	regions: [],
	country_data: [],
	selected_region: 'EMEA',
	selected_country: null,
	style: style,
	ready: false,
	get filtered_country_data() {
		if ( !this.country_data ) { return []; }

		return this.country_data.filter( r => {
			return this.selected_region === '*' ? true : r.region === this.selected_region;
		});
	},
	get show_table() {
		return this.selected_categories.length > 0;
	},
	get payments_checked() {
		return this.selected_categories.includes('accept_payments');
	},
	get payouts_checked() {
		return this.selected_categories.includes('send_payouts');
	},
	get issuing_checked() {
		return this.selected_categories.includes('issue_cards');
	},
	get virtual_accounts_checked() {
		return this.selected_categories.includes('create_virtual_accounts');
	},
	get selected_country_data() {
		const data = this.country_data.find(r => r.country_name === this.selected_country);
		if ( !data ) {
			return {
				url: '',
				payment_methods: [],
				payout_methods: [],
			};
		}

		return data;
	},
	select_country(country) {
		this.selected_country = (this.selected_country === country.country_name) ? null : country.country_name;
		if (this.selected_country && window.innerWidth <= 768) {
			this.$root.scrollIntoView({ behavior: 'smooth', block: 'start' });
			this.$nextTick( () => {
				this.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
			});
		}
	},
	saveState(name, value) {
		const url = new URL(window.location.href);
		url.searchParams.set(name, value);
		history.pushState(null, document.title, url.toString());
	},
	getState(name) {
		return new URLSearchParams(location.search).get(name);
	},
	init() {
		this.loadRegions();
		this.loadCountryData();

		document.querySelector('body').classList.add('no-overflow');
		this.$nextTick( () => {
			const region = this.getState('region');
			if ( region ) {
				this.selected_region = region;
			}

			const categories = this.getState('selected-categories');
			if ( categories ) {
				this.selected_categories = JSON.parse(categories);
			}
			this.ready = true;
		});
		this.$watch('selected_region', (value) => {
			if ( this.ready ) {
				this.saveState('region', value);
			}
		});

		this.$watch('selected_categories', (value) => {
			if ( this.ready ) {
				this.saveState('selected-categories', JSON.stringify(value));
			}
		});
	},
	loadRegions() {
		this.regions = JSON.parse(this.$refs.regionData.textContent);
	},
	loadCountryData() {
		this.country_data = JSON.parse(this.$refs.countryData.textContent);
	},
	countryCountForRegion(region) {
		return this.country_data.filter(r => r.region === region).length;
	},
});
